import Vue from 'vue'

Vue.filter('birthday' ,info => {
  if(info) {
    let date = info.split('-')
    return `${date[0]}年${date[1]}月${date[2]}日`
  }

})
